module.exports = __webpack_public_path__ + "img/zuofei.de177858.png";